/*
 * @Author: TANG
 * @Date: 2022-06-20 16:44:27
 * @LastEditors: TANG 15390913806@163.com
 * @LastEditTime: 2022-07-02 09:08:59
 */
import React, { lazy } from 'react';
import { DefaultLayout } from '@layouts';

import appRoutes from './appRoutes';

const Login = lazy(() => import('../modules/login/login'));
const NotFound = lazy(() => import('@modules/error/notFound'));
const FddV4EditReturn = lazy(() => import('@modules/contractMannage/contractTemplate/FillEdit'));
const FddEditRedirect = lazy(() => import('@modules/contractManageV5/contractTemplate/fdd/editRedirect'));
const FddV5EditRedirect = lazy(() => import('@modules/contractManageV5/contractTemplate/fddV5/editRedirect'));
const BossAuthCallback = lazy(() => import('@modules/contractManageV5/businessEntity/bossAuthCallback'));

export default [
  {
    path: '/',
    element: <DefaultLayout />,
    children: appRoutes,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/contractTemp/:contractMainTempId/fill/edit',
    element: <FddV4EditReturn />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
  {
    path: '/fdd/contractTemp/:contractMainTempId/fill/editRedirect',
    element: <FddEditRedirect />,
  },
  {
    path: '/fddV5/contractTemp/:contractMainTempId/fill/editRedirect',
    element: <FddV5EditRedirect />,
  },
  {
    path: '/bossAuthCallback',
    element: <BossAuthCallback />,
  },
];
